import React, { FC } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { Space } from '~/components';
import { ArrowForwardIcon } from '~/img';
import theme from '~/theme';
import { login } from '~/routes';

const GoToLoginButton: FC = () => {
  const { t } = useTranslation('passwordReset');
  const history = useHistory();
  const onClick = () => {
    history.push(`/${login}`);
  };
  return (
    <Container>
      <Space
        className="GoToLoginButton-GoBackSpace"
        size={8}
        align="center"
        fullWidth={false}
        onClick={onClick}
      >
        <ArrowForwardIcon className="GoToLoginButton-GoBackIcon" />
        <>
          <div className="GoToLoginButton-GoBackText">{t('Back to login page')}</div>
        </>
      </Space>
    </Container>
  );
};

const Container = styled.div`
  .GoToLoginButton-GoBackSpace {
    cursor: pointer;
    .GoToLoginButton-GoBackIcon {
      font-size: 17px;
      display: flex;
      color: ${theme.textColor};
      transform: rotate(180deg);
    }
    .GoToLoginButton-GoBackText {
      font-size: 12px;
      line-height: 14px;
      color: ${theme.disabledColor};
    }
  }
`;

export default GoToLoginButton;
